// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"d8ae28a1","120":"d9b33215","237":"1b5e173e","312":"9b563ef9","623":"3de52d3f","630":"e90522e5","648":"81b44080","674":"071faf70","687":"bbee3ffb","751":"f64228c8","793":"24e08669","853":"9b1860f3","897":"f2209476","940":"7bf7067e"}[chunkId] + ".chunk.js";
};